import type { ReactNode } from 'react';
import { type ActivateLocale, LocaleActivationContext } from './locale-activation-context';

/**
 * Cómo se activa un idioma (cargar el catálogo, `i18n.activate`, `lang` del documento, dayjs) lo sabe
 * el código existente (`utils/i18n/activateLocale`), que `fsd/` no puede importar. `FsdContext` lo
 * inyecta acá; en los tests va un activador de prueba.
 */
export function LocaleActivationProvider({
  activate,
  children,
}: {
  activate: ActivateLocale;
  children: ReactNode;
}) {
  return (
    <LocaleActivationContext.Provider value={activate}>{children}</LocaleActivationContext.Provider>
  );
}
